<template>
    <nav :class="`footer-list footer-list--${title.toLowerCase()}`">
        <h5
            v-if="title"
            class="footer-list__title"
        >
            {{ title }}
        </h5>

        <ul class="footer-list__list">
            <li
                v-for="(item, index) in items"
                :key="index"
                class="footer-list__item"
            >
                <TheFooterLink :item="item" />
            </li>
        </ul>
    </nav>
</template>

<script setup>
const { title, items } = defineProps({
    title: {
        type: String,
        required: false,
        default: null
    },
    items: {
        type: Array,
        required: true,
        default: () => []
    }
});
</script>

<style lang="less">
.footer-list__title {
    .typography-label-secondary;
    margin-bottom: .5rem;
}

.footer-list__item {
    margin: 0;
    padding: 0;
}

.footer-list__list {
    .list-clean;
}
</style>
